<template>
  <h3 style="text-align: center" v-if="!isOk">
    Incorrect URL.
    <br />
    <br />
    Example:
    {{
      `${origin}/DataPipelineTransformation/InstrumentSource/0B153Z93-E039-41FB-BCF6-12AA81A0FBSN`
    }}
  </h3>

  <div v-if="isOk" class="py-4 container-fluid w-75">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="marketWripper">
            <div style="font-size: 1rem">
              <div class="col-md-12" style="margin-top: 24px" />

              <h2 class="text-center">Edit Instrument Source</h2>
              <div class="col-md-12" style="margin-top: 24px" />

              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Instrument Source Name:</label
                >
                <argon-input
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  readonly
                  :value="Model.InstrumentSource.Name"
                />
              </div>
              <div class="row">
                <label for="firstName" class="col-sm-2 col-form-label"
                  >Source:</label
                >
                <argon-input
                  class="col-sm"
                  type="text"
                  name="name"
                  size="sm"
                  readonly
                  :value="Model.Source"
                />
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="row">
                <label for="firstName" class="col col-form-label"
                  >Assigned to Instrument:</label
                >
                <select
                  class="form-select col-6 instrumentSelect select customSelect"
                  aria-label="Default select example"
                  size="sm"
                  v-model="selectedInstrumentName"
                >
                  <option
                    :selected="market.Id === Model.MarketId"
                    v-for="market in filteredInstruments"
                    :key="market.Id"
                  >
                    {{ market.Name }}
                  </option>
                </select>
                <input
                  @change="searchChange"
                  class="search col"
                  placeholder="Find an Instrument"
                />
              </div>
              <div class="col-md-12" style="margin-top: 24px" />
              <div class="buttons">
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  :isLoading="saveButtonClicked"
                  :isLoadingText="'Saving...'"
                  @click="Save"
                  style="width: 200px; margin-left: 20px"
                  >Save</argon-button
                >
                <argon-button
                  variant="gradient"
                  color="light"
                  class="ml-2"
                  size="md"
                  @click="Close"
                  style="width: 200px; margin-left: 20px"
                  >Close</argon-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="col-md-12" style="margin-top: 24px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.search {
  margin-right: 10px;
  border-radius: 10px;
  border: transparent;
}
.marketWripper {
  padding: 10px;
}

.buttons {
  text-align: center;
}
.instrumentSelect {
  width: 64%;
}
.customSelect {
  margin-right: 10px;
  margin-left: 12px;
  height: 40px;
  -webkit-appearance: menulist;
}

.search:focus {
  outline: none;
}

@media only screen and (max-width: 1024px) {
  .instrumentSelect {
    width: 35%;
  }
}

@media only screen and (max-width: 1040) {
  .instrumentSelect {
    width: 55%;
  }
}
</style>
<script>
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { SendGETServerAPI, SendPOSTServerAPI } from "@/customFunctions/Api.js";
import { Toaster } from "@/customFunctions/Utils.js";

export default {
  name: "data-pipeline-instrument",
  data() {
    return {
      Model: {},
      selectedInstrumentName: "",
      filteredInstruments: [],
      saveButtonClicked: false,
      component: "",
      origin: window.location.origin,
      isOk: false,
    };
  },
  async mounted() {
    this.$store.commit("setShowPreloader", true);
    this.component = this.$route.params.pathMatch[0];
    try {
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      const splittedRoutePath = this.$route.path.split("/");
      const id = regexExp.test(splittedRoutePath[splittedRoutePath.length - 1])
        ? splittedRoutePath[splittedRoutePath.length - 1]
        : "";

      this.Model = await SendGETServerAPI(
        `dataPipelineTransformation/InstrumentSource/${id}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      );

      this.selectedInstrumentName = this.Model.Instruments.find(
        (x) => x.Id === this.Model.InstrumentId
      ).Name;

      this.filteredInstruments = this.Model.Instruments.slice(0, 50);
      this.filteredInstruments.push(
        this.Model.Instruments.find((x) => x.Id === this.Model.InstrumentId)
      );
      this.isOk = this.Model.isOk;
    } catch {
      this.Model = {};
    }

    this.$store.commit("setShowPreloader", false);
  },
  components: { ArgonInput, ArgonButton },
  methods: {
    searchChange(e) {
      const searchValue = e.target.value;
      if (searchValue === "") {
        this.filteredInstruments = this.Model.Instruments.slice(0, 50);
        this.filteredInstruments.push(
          this.Model.Instruments.find((x) => x.Id === this.Model.InstrumentId)
        );
        this.selectedInstrumentName = this.selectedInstrumentName = this.Model.Instruments.find(
          (x) => x.Id === this.Model.InstrumentId
        ).Name;
        return;
      }

      const foundInstruments = this.Model.Instruments.filter((x) =>
        x.Name.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (foundInstruments.length > 0)
        this.filteredInstruments = foundInstruments;
      else {
        this.filteredInstruments = [{ Id: 0, Name: "No Instruments Found" }];
        this.selectedInstrumentName = "No Instruments Found";
      }
    },
    async Save() {
      if (this.selectedInstrumentName === "No Instruments Found") {
        this.Toaster("No Instrument Selected", "Error", "danger");
        return;
      }

      this.saveButtonClicked = true;
      const instrumentId = this.Model.Instruments.find(
        (x) => x.Name === this.selectedInstrumentName
      ).Id;
      const resp = await SendPOSTServerAPI(
        `dataPipelineTransformation/InstrumentSource/Save?InstrumentSourceId=${this.Model.InstrumentSource.Id}&InstrumentId=${instrumentId}`,
        {
          Authorization: "Bearer " + this.$store.state.security.accessToken,
        }
      ).then((r) => r.json());

      if (resp.isOk) this.Toaster("Data has been saved.", "Success", "success");
      else this.Toaster("Some Server Error...", "Error", "danger");
      this.saveButtonClicked = false;
    },
    Close() {
      window.close();
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
